/**
 * Floating WhatsApp Share button (visible on mobile).
 * Composes a short share message with today's latest 3 results + site URL.
 */
export default function WhatsAppShare({ latest, dateLabel }) {
  const share = () => {
    const j = latest?.jackpot_regel || "--";
    const g = latest?.golden || "--";
    const a = latest?.aakhri_dao || "--";
    const siteUrl = window.location.origin;

    const text =
      `LuckyWin5G Latest Result (${dateLabel})\n\n` +
      `Jackpot Royal: ${j}\n` +
      `Golden: ${g}\n` +
      `Aakhri Dao: ${a}\n\n` +
      `Live results: ${siteUrl}`;

    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      type="button"
      className="wa-fab"
      aria-label="Share on WhatsApp"
      onClick={share}
      data-testid="whatsapp-share-btn"
    >
      <svg
        className="wa-fab-icon"
        viewBox="0 0 32 32"
        width="26"
        height="26"
        aria-hidden="true"
      >
        <path
          fill="#ffffff"
          d="M16 3C9 3 3.4 8.6 3.4 15.6c0 2.4.7 4.7 1.9 6.7L3 29l6.9-2.2c2 1.1 4.2 1.7 6.4 1.7 7 0 12.6-5.6 12.6-12.6S23 3 16 3zm0 22.9c-2 0-3.9-.5-5.6-1.5l-.4-.2-4.1 1.3 1.3-4-.3-.4c-1.1-1.7-1.7-3.7-1.7-5.7 0-5.9 4.8-10.7 10.7-10.7s10.7 4.8 10.7 10.7-4.7 10.5-10.6 10.5zm5.9-7.9c-.3-.2-1.9-.9-2.2-1s-.5-.2-.7.2c-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1-1.7-.8-2.8-1.5-3.9-3.4-.3-.5.3-.5.8-1.6.1-.2.1-.4 0-.5-.1-.2-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1.1 2.8 1.2 3c.2.2 2.1 3.2 5.1 4.5 1.9.7 2.6.8 3.5.7.5-.1 1.8-.7 2.1-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z"
        />
      </svg>
      <span className="wa-fab-label">Share</span>
    </button>
  );
}
